import { LitElement, html, svg } from 'lit';

export class IconWheelchair32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Rullestol</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM27 31h-2v-6a4 4 0 0 0-4-4h-6a2 2 0 0 1-2-2V9.086"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 15h-8a8 8 0 1 0 8 8v-1.883"></path></svg>`; }
}
if (!customElements.get('f-icon-wheelchair32', IconWheelchair32)) {
  customElements.define('f-icon-wheelchair32', IconWheelchair32);
}